import { render } from "./BenefitIcons.vue?vue&type=template&id=9f357258&scoped=true"
import script from "./BenefitIcons.vue?vue&type=script&lang=js"
export * from "./BenefitIcons.vue?vue&type=script&lang=js"

import "./BenefitIcons.vue?vue&type=style&index=0&id=9f357258&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f357258"]])

export default __exports__